export var bytesToKilobytes = function bytesToKilobytes(size) {
  if (!size) {
    return undefined;
  }
  return "".concat(Math.ceil(size / 1024), " \u041A\u0431");
};
export var parseFileName = function parseFileName(fileName) {
  if (!fileName) {
    return {
      name: '',
      type: ''
    };
  }
  var lastDotIndex = fileName.lastIndexOf('.');
  var name = fileName.slice(0, lastDotIndex);
  var type = fileName.slice(lastDotIndex + 1);
  return {
    name: name,
    type: type
  };
};